import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useHeaderNavigationContext } from "../context/HeaderNavigationContext";

const useNavigateToSection = () => {
  const navigate = useNavigate();
  const { setIsNavOpen, setSectionId } = useHeaderNavigationContext();

  const scrollToSection = (sectionId: string) => {
    setIsNavOpen(false);
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = document.querySelector("header")?.clientHeight || 0;
      console.log(headerHeight);
      const sectionTop = section.offsetTop - headerHeight;
      console.log(sectionTop);
      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });
    }
  };

  const navigateToSection = async (sectionId: string) => {
    if (window.location.pathname !== "/") {
      setIsNavOpen(false);
      setSectionId(sectionId);
      // セクションIDを設定
      // ページ遷移を実行し、遷移完了を待つ
      await navigate("/", {
        replace: true,
        state: { scrollToSectionId: sectionId },
      });
      // ページ遷移後、スクロール位置をトップにリセット
      window.scrollTo(0, 0);
      // 必要なセクションにスクロール（次のレンダリングサイクルで実行）
      setTimeout(() => scrollToSection(sectionId), 0);
    } else {
      setIsNavOpen(false);
      setSectionId(sectionId);
      scrollToSection(sectionId);
    }
  };

  return navigateToSection;
};

export default useNavigateToSection;
